type Market = {
  betType: string;
  value: string;
};

const formatMarket = ({ betType, value }: Market): string => {
  const marketName = `${betType}`.toUpperCase();

  if (
    betType === "oe" ||
    betType === "cr" ||
    betType === "1h/cr" ||
    betType === "2h/cr"
  ) {
    return marketName;
  }

  return `${marketName} [${value}]`;
};

export default formatMarket;
